export default () => ({
  certs: null,
  certsList: null,
  loading: false,
  paginator: { page: 0, size: 0, total: 0, loadingPage: null },
  sort: { field: "name", order: "asc" },
});
